/**
 * Module-level singleton for the listener handles redux cannot hold
 * (the Firestore onSnapshot unsubscribe and the RTDB ref detach callbacks).
 * Thunks call into this registry to start/stop listeners; the registry keeps
 * the side-effecting references out of serializable redux state.
 */
type Unsub = () => void

interface Registry {
  ordersUnsub: Unsub | null
  driverDetachers: Unsub[]
}

const registryState: Registry = {
  ordersUnsub: null,
  driverDetachers: [],
}

export const listenerRegistry = {
  /** Register the orders onSnapshot unsubscribe, tearing down any prior one first. */
  startOrders(unsub: Unsub): void {
    if (registryState.ordersUnsub) {
      try {
        registryState.ordersUnsub()
      } catch {
        /* ignore */
      }
    }
    registryState.ordersUnsub = unsub
  },

  /** Tear down the orders listener if one is active. Safe to call repeatedly. */
  stopOrders(): void {
    if (registryState.ordersUnsub) {
      try {
        registryState.ordersUnsub()
      } catch {
        /* ignore */
      }
      registryState.ordersUnsub = null
    }
  },

  /** Register a driver-location RTDB detach callback. */
  addDriverDetach(detach: Unsub): void {
    registryState.driverDetachers.push(detach)
  },

  /** Detach every registered driver-location listener and clear the list. */
  stopAllDrivers(): void {
    registryState.driverDetachers.forEach((detach) => {
      try {
        detach()
      } catch {
        /* ignore */
      }
    })
    registryState.driverDetachers = []
  },
}
